<div #wrapper class="wrapper" infiniteScroll [style.height]="containerHeight" [class.expand]="expand" (scroll)="onScroll()" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" [scrollWindow]="false" (scrolled)="onScrolled()">
  <ng-content></ng-content>
</div>
<a *ngIf="containerHeight" href="javascript:void(0)" class="more d-lg-none" (click)="toggleExpand()">
  <ng-container *ngIf="expand" i18n="@@scrollable.viewLess">VIEW LESS</ng-container>
  <ng-container *ngIf="!expand" i18n="@@scrollable.viewMore">VIEW MORE</ng-container>
</a>
<a *ngIf="showTopIndicator" href="" class="scroll-indicator scroll-top" (click)="scrollUp()">
  <div class="img">
    <img src="assets/images/icons/chevron-up.svg" alt="">
  </div>
</a>
<a *ngIf="showBottomIndicator" href="" class="scroll-indicator scroll-bottom" (click)="scrollDown()">
  <div class="img">
    <img src="assets/images/icons/chevron-down.svg" alt="">
  </div>
</a>